/* Lieferadresse korrigieren im Shop (Roadmap 3.48 Paket A-T, Konzept docs/konzept_service_im_shop.md in mhsys).
 * Geladen aus layout/theme.liquid nur auf /pages/adresse (template.suffix "adresse").
 *
 * Endpunkte (Enna, Paket A):
 *   POST /apps/kunde?bereich=adresse&teil=laden     { token }
 *     -> { ok, nummer, datum, adresse:{name, firma, strasse, zusatz, zusatz2, plz, ort, land} } | { ok:false, fehler, meldung }
 *   POST /apps/kunde?bereich=adresse&teil=speichern { token, adresse:{…}, schluessel }
 *     -> { ok, meldung } | { ok:false, fehler, meldung, felder? }
 *   POST /apps/kunde?bereich=status&teil=code       { code }  (Einmal-Code aus der Mail-Weiche, wie 3.41)
 *
 * Token wie auf der Bestellstatus-Seite (sessionStorage "mhsysBestellstatus") - nie in einer Adresse. Der Einmal-Code
 * kommt als #c=... und wird im Kopf der Seite vor jedem Pixel aus der Adresse genommen (window.mhsysBsCode).
 * Werte nur ueber value/textContent. schluessel = Idempotenz gegen doppeltes Speichern (Konzept 3.3).
 */
(function () {
  "use strict";
  var wurzel = document.querySelector("[data-mhsys-adresse]");
  if (!wurzel || wurzel.getAttribute("data-ad-bereit")) return;
  wurzel.setAttribute("data-ad-bereit", "1");

  var SCHLUESSEL = "mhsysBestellstatus";
  var formular = wurzel.querySelector("[data-ad-formular]");
  var speichern = wurzel.querySelector("[data-ad-speichern]");
  var FELDER = ["name", "firma", "strasse", "zusatz", "zusatz2", "plz", "ort"];
  var PFLICHT = { name: "Bitte gib deinen Namen ein.", strasse: "Bitte gib Straße und Hausnummer ein.", plz: "Bitte gib die PLZ ein.", ort: "Bitte gib den Ort ein." };
  var stand = null; // letzte abgeschickte Werte + Schluessel
  var laeuft = false;

  function text(v) { return v === null || v === undefined ? "" : String(v); }
  function lesen() { try { return sessionStorage.getItem(SCHLUESSEL) || ""; } catch (e) { return ""; } }
  function merken(t) { try { t ? sessionStorage.setItem(SCHLUESSEL, t) : sessionStorage.removeItem(SCHLUESSEL); } catch (e) {} }
  // Mit Zeitlimit (layout/theme.liquid, Roadmap 7.44): antwortet mhsys nicht, kommt der Fehler-Zustand statt ewigem Laden
  function holen(url, init) { return window.mhsysNetz ? window.mhsysNetz.holen(url, init) : fetch(url, init); }
  function senden(bereich, teil, daten) {
    return holen("/apps/kunde?bereich=" + bereich + "&teil=" + teil, {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify(daten || {}),
      credentials: "same-origin",
      cache: "no-store",
    }).then(function (r) {
      return r.json().catch(function () { return { ok: false, fehler: "antwort" }; }).then(function (j) {
        return j && typeof j === "object" ? j : { ok: false, fehler: "antwort" };
      });
    });
  }
  function zustand(name) {
    wurzel.querySelectorAll("[data-ad-zustand]").forEach(function (z) { z.hidden = z.getAttribute("data-ad-zustand") !== name; });
  }
  function hinweis(satz) {
    wurzel.querySelector("[data-ad-hinweis]").textContent = satz;
    zustand("hinweis");
  }
  function meldung(satz) {
    var m = wurzel.querySelector("[data-ad-meldung]");
    m.textContent = satz || "";
    m.hidden = !satz;
  }
  function feldfehler(f) {
    Object.keys(PFLICHT).forEach(function (k) {
      var p = wurzel.querySelector('[data-ad-feldfehler="' + k + '"]');
      var satz = f && f[k] ? text(f[k]) : "";
      if (p) { p.textContent = satz; p.hidden = !satz; }
      satz ? formular.elements[k].setAttribute("aria-invalid", "true") : formular.elements[k].removeAttribute("aria-invalid");
    });
  }
  function schluessel() {
    var b = new Uint8Array(16);
    window.crypto.getRandomValues(b);
    return Array.prototype.map.call(b, function (x) { return ("0" + x.toString(16)).slice(-2); }).join("");
  }
  var OHNE_ZUGANG = "Öffne zuerst deine Bestellung – dann kannst du hier die Lieferadresse korrigieren.";

  /* ---- Laden ---- */
  function laden(token) {
    zustand("laden");
    senden("adresse", "laden", { token: token }).then(function (a) {
      if (!a.ok) {
        if (a.fehler === "token") merken("");
        if (a.fehler === "token" || a.fehler === "nicht_noetig" || a.fehler === "archiviert" || a.fehler === "grenze") {
          hinweis(text(a.meldung) || OHNE_ZUGANG);
          return;
        }
        zustand("fehler");
        return;
      }
      var ad = a.adresse || {};
      FELDER.forEach(function (k) { formular.elements[k].value = text(ad[k]); });
      wurzel.querySelector("[data-ad-land]").textContent = text(ad.land);
      var unter = wurzel.querySelector("[data-ad-unter]");
      unter.textContent = a.nummer ? "Bestellung " + text(a.nummer) + (a.datum ? " vom " + text(a.datum) : "") : "";
      unter.hidden = !a.nummer;
      feldfehler(null);
      meldung("");
      zustand("formular");
    }).catch(function () { zustand("fehler"); });
  }

  function start() {
    var code = window.mhsysBsCode;
    window.mhsysBsCode = "";
    if (code) {
      zustand("laden");
      senden("status", "code", { code: code }).then(function (a) {
        if (a.ok && a.token) { merken(a.token); laden(a.token); return; }
        hinweis(text(a.meldung) || OHNE_ZUGANG);
      }).catch(function () { zustand("fehler"); });
      return;
    }
    var token = lesen();
    if (token) { laden(token); return; }
    hinweis(OHNE_ZUGANG);
  }

  /* ---- Speichern ---- */
  formular.addEventListener("submit", function (ev) {
    ev.preventDefault();
    if (laeuft) return;
    var w = {};
    FELDER.forEach(function (k) { w[k] = text(formular.elements[k].value).trim(); });
    var fehler = {};
    Object.keys(PFLICHT).forEach(function (k) { if (!w[k]) fehler[k] = PFLICHT[k]; });
    feldfehler(fehler);
    meldung("");
    if (Object.keys(fehler).length) { formular.elements[Object.keys(fehler)[0]].focus(); return; }
    var token = lesen();
    if (!token) { hinweis(OHNE_ZUGANG); return; }
    // Gleiche Angaben = gleicher Schluessel: ein Doppelklick oder ein zweiter Versuch speichert nicht zweimal
    var gleich = stand && FELDER.every(function (k) { return stand.werte[k] === w[k]; });
    stand = { werte: w, schluessel: gleich ? stand.schluessel : schluessel() };
    laeuft = true;
    speichern.disabled = true;
    senden("adresse", "speichern", { token: token, adresse: w, schluessel: stand.schluessel }).then(function (a) {
      if (a.ok) {
        if (a.meldung) wurzel.querySelector("[data-ad-erfolg]").textContent = text(a.meldung);
        zustand("gespeichert");
        return;
      }
      if (a.fehler === "felder") { feldfehler(a.felder || {}); meldung(text(a.meldung)); return; }
      if (a.fehler === "token" || a.fehler === "nicht_noetig") { if (a.fehler === "token") merken(""); hinweis(text(a.meldung) || OHNE_ZUGANG); return; }
      if (a.fehler === "grenze") { meldung(text(a.meldung) || "Bitte warte einen Moment und versuch es dann noch einmal."); return; }
      zustand("fehler");
    }).catch(function () { zustand("fehler"); }).then(function () { laeuft = false; speichern.disabled = false; });
  });

  // Nach einem Fehler beim Speichern zurueck ins Formular (die Eingaben stehen noch da), sonst neu laden
  wurzel.querySelector("[data-ad-nochmal]").addEventListener("click", function () { stand ? zustand("formular") : start(); });

  start();
})();
